import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyModel } from '../../models/data/currency.model';
import { CurrencyUtilities } from '../../utilities/currency.utilities';

@Pipe({
  name: 'CurrencyDisplay'
})
export class CurrencyDisplayPipe implements PipeTransform {

  transform(amount: number, currency: CurrencyModel | undefined): string {
    return CurrencyUtilities.convertMinorUnitToDisplayFormat(amount, currency);
  }

}
